import { FormSectionProps } from '../../interfaces/form'
import FormWizard from '../wizard'
// import { lighten } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
// import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

// import FormRadio from '../../components/FormRadio'
import FormField from '../../components/FormField'

// import theme from '../../theme'

// const radioStyle = {
//   paddingBottom: 0,
//   display: 'none',
// }

// const radioOverrideMuiStyle = {
//   '&.MuiRadio-root': {
//     '&.Mui-checked + span': {
//       backgroundColor: `${theme.palette.primary.main} !important`,
//       color: '#FFF !important',
//     },
//   },
// }

// const textStyle = {
//   justifyContent: 'center',
//   alignItems: 'center',
//   borderRadius: 4,
//   display: 'inline-flex',
//   border: `1px solid ${theme.palette.primary.main}`,
//   marginTop: 0,
//   marginRight: 6,
//   marginBottom: 10,
//   fontWeight: 'bold',
//   verticalAlign: 'top',
//   width: '100%',
//   height: '100%',
//   minHeight: 80,
//   cursor: 'pointer',
//   backgroundColor: lighten(theme.palette.primary.main, 0.8),
// }

const DateOfBirth = () => {
  return (
    <div id="dateOfBirth" style={{ marginBottom: 40 }}>
      <Typography variant="h6" color="secondary" sx={{ marginBottom: 2 }}>
        How old is your partner?
      </Typography>
      <FormField
        id="partnerAge"
        name="partnerAge"
        placeholder="Age"
        type="number"
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
      />
      {/* <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthDay"
            name="dateOfBirth.day"
            placeholder="DD"
            type="number"
            inputProps={{
              style: { textAlign: 'center' },
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthMonth"
            name="dateOfBirth.month"
            type="number"
            placeholder="MM"
            inputProps={{
              style: { textAlign: 'center' },
              type: 'number',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormField
            id="dateOfBirthYear"
            name="dateOfBirth.year"
            type="number"
            placeholder="YYYY"
            inputProps={{
              style: { textAlign: 'center' },
              type: 'number',
            }}
          />
        </Grid>
      </Grid> */}
    </div>
  )
}

// const Gender = () => {
//   return (
//     <div id="gender" style={{ marginBottom: 40 }}>
//       <Typography variant="h6" color="secondary" sx={{ marginBottom: 2 }}>
//         Are you male or female?
//       </Typography>
//       <Grid container spacing={2} sx={{ mb: 14 }}>
//         <Grid item xs={12} md={3}>
//           <label htmlFor="male" style={{ textAlign: 'center' }}>
//             <FormRadio
//               id="male"
//               name="gender"
//               value="Male"
//               style={radioStyle}
//               overrideMuiStyle={radioOverrideMuiStyle}
//             />
//             <Typography component="span" style={textStyle}>
//               Male
//             </Typography>
//           </label>
//         </Grid>
//         <Grid item xs={12} md={3}>
//           <label htmlFor="female" style={{ textAlign: 'center' }}>
//             <FormRadio
//               id="female"
//               name="gender"
//               value="Female"
//               style={radioStyle}
//               overrideMuiStyle={radioOverrideMuiStyle}
//             />
//             <Typography component="span" style={textStyle}>
//               Female
//             </Typography>
//           </label>
//         </Grid>
//       </Grid>
//     </div>
//   )
// }

const PersonalDetails = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <DateOfBirth />
          {/* <Gender /> */}
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default PersonalDetails
